import { Dispatch } from 'redux';
import { SortingGeneric, TableColumnWidthInfoGeneric } from '../history-table-settings/types';
import { setColumnOrderAction, setColumnSizeAction, setColumnSortingAction } from './actions';
import { GPSHistoryDtoKeys } from './types';

export function setSorting(sorting: SortingGeneric<GPSHistoryDtoKeys>[]) {
	return (dispatch: Dispatch<any>) => {
		dispatch(setColumnSortingAction(sorting));
	};
}

export function setSize(columnWidths: TableColumnWidthInfoGeneric<GPSHistoryDtoKeys>[]) {
	return (dispatch: Dispatch<any>) => {
		dispatch(setColumnSizeAction(columnWidths));
	};
}

export function setOrder(columnOrder: GPSHistoryDtoKeys[]) {
	return (dispatch: Dispatch<any>) => {
		dispatch(setColumnOrderAction(columnOrder));
	};
}